<template>
    <div class="content create_report_step">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <nav aria-label="breadcrumb" role="navigation" class="m-0">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="{ name: 'Search' }">Home</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Valuation Multiple</li>
                </ol>
            </nav>
        </div>
        <div class="content new-profile">
            <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 mb-4">
                    <div class="md-layout md-gutter md-alignment-center-center">
                        <h1 class="section_header">Valuation Multiples</h1>
                        <div class="searchResultWpr">
                            <div
                                class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 profile-left-sec"
                            >
                                <div>
                                    <p class="description">
                                        Select an industry and sales group to display Valuations Price/Earnings and Price/Revenue multiples.
                                        Valuations are derived from closed business sales as well as enterprise-level revenue and industry
                                        financial analysis developed by Bizminer.Multiples are updated four times per year and analyze 34,000
                                        business sale transactions through 2020q1.
                                    </p>
                                </div>
                            </div>
                            <div
                                class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 profile-right-sec"
                            >
                                <div class="md-layout">
                                    <div
                                        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100"
                                    >
                                        <div
                                            class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
                                        >
                                            <div
                                                v-if="this.dataAccess && this.dataAccess.allowedSalesClasses.all"
                                            >
                                                <div>
                                                    <h3>Searches used:{{ this.dataAccess.searchesUsed.all }}/{{ this.dataAccess.searchesAllowed.all }}</h3>
                                                </div>
                                            </div>
                                            <div v-else-if="this.dataAccess">
                                                <div
                                                    v-for="(item, key) in this.dataAccess.searchesAllowed"
                                                    :key="item"
                                                >
                                                    <h3>Searches used({{ key }}}):{{ dataAccess.searchesUsed[key] }}/{{ item }}</h3>
                                                </div>
                                            </div>
                                            <div
                                                v-if="this.multSearchesResult && this.multCount > 2"
                                            >
                                                <md-button
                                                    @click="confirmationModal = true"
                                                    class="md-info md-block access-button"
                                                >Add To Cart</md-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="md-layout">
                    <div
                        class="new-profile md-layout-item md-medium-size-50 md-xsmall-size-50 md-size-50 pr-0"
                        @click="selectArea($event)"
                    >
                        <industry-select :dataAccess="this.dataAccess" />
                    </div>
                    <div
                        :hidden="isHiddenSalesSelect"
                        class="new-profile md-layout-item md-medium-size-50 md-xsmall-size-50 md-size-50 pl-0"
                        @click="selectArea($event)"
                    >
                        <sales-select :dataAccess="this.dataAccess" />
                    </div>
                </div>
            </div>
            <div
                class="md-layout div-table"
                v-if="this.multSearchesResult && this.multCount > 2 && this.currentIndustry && this.currentSalesClass"
            >
                <div class="md-layout-item md-medium-size-100 md-size-100">
                    <md-table table-header-color="blue" class="profit-and-loss-table">
                        <md-table-row class="table-header">
                            <md-table-cell
                                md-label="headerData.client_name"
                                class="md-table-side-label"
                            ></md-table-cell>

                            <md-table-cell md-label="Trend" class="table_chart">Sales Multiples</md-table-cell>
                            <md-table-cell>Earnings Multiples</md-table-cell>
                        </md-table-row>
                        <md-table-row class="table-header">
                            <md-table-cell class="table-title">Q1</md-table-cell>

                            <md-table-cell class="table-content">{{ multSearchesResult.sales.low }}</md-table-cell>
                            <md-table-cell
                                class="table-content"
                            >{{ multSearchesResult.earnings.low }}</md-table-cell>
                        </md-table-row>
                        <md-table-row class="table-header">
                            <md-table-cell class="table-title">Median</md-table-cell>

                            <md-table-cell class="table-content">{{ multSearchesResult.sales.med }}</md-table-cell>
                            <md-table-cell
                                class="table-content"
                            >{{ multSearchesResult.earnings.med }}</md-table-cell>
                        </md-table-row>
                        <md-table-row class="table-header">
                            <md-table-cell class="table-title">Q3</md-table-cell>

                            <md-table-cell class="table-content">{{ multSearchesResult.sales.high }}</md-table-cell>
                            <md-table-cell
                                class="table-content"
                            >{{ multSearchesResult.earnings.high }}</md-table-cell>
                        </md-table-row>
                    </md-table>
                    <div class="div-button">
                        <md-button
                            @click="resetSearch"
                            class="md-info md-block access-button reset-button"
                        >Reset</md-button>
                    </div>
                </div>
            </div>
            <div
                class="md-layout div-table"
                v-else-if="this.currentIndustry && this.currentSalesClass"
            >
                <h1 class="section_header">There is no results to show</h1>
            </div>
            <div class="md-layout div-table" v-else></div>
        </div>
        <div class="prospect_content">
            <modal v-if="confirmationModal" @close="confirmationModal = false">
                <template slot="header">
                    <button type="button" class="close_btn" @click="confirmationModal = false">
                        <md-icon>clear</md-icon>
                    </button>
                </template>
                <template slot="body">
                    <div class="field_wpr">
                        <h4 class="modal-title">
                            Please confirm access to this product with the selected parameters.
                            Click Review to review the parameters or Access Now to access this product.
                        </h4>
                        <div class="ml-4 md-layout">
                            <md-button
                                @click="confirmationModal = false"
                                class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40"
                            >Review</md-button>
                            <md-button
                                
                                class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40"
                            >Access Now</md-button>
                        </div>
                    </div>
                </template>
            </modal>
        </div>
    </div>
</template>
<script>

import SalesSelect from '../ValuationMultiple/_partials/SalesSelect';
import IndustrySelect from '../ValuationMultiple/_partials/IndustrySelect';
import axios from 'axios';
import { Modal} from '@/components';
export default {
    name: "ValuationMultiple",
    components: {
        SalesSelect,
        IndustrySelect,
        Modal,
    },
    data() {
        return {
            confirmationModal: false,
            dataAccess: null,
            isHiddenSalesSelect: true,
        }
    },
    mounted() {
        this.$store.commit('MULT_SET_CURRENT_INDUSTRY', null);
        this.$store.commit('MULT_SET_CURRENT_SALES_CLASS', null);
        this.getData();
    },
    computed: {
        multCount() {
            return this.$store.getters.multCount;
        },
        multSearchesResult() {
            return this.$store.getters.multSearchesResult;
        },
        currentIndustry() {
            return this.$store.getters.multCurrentIndustry;
        },
        currentSalesClass() {
            return this.$store.getters.multCurrentSalesClass;
        }
    },
    methods: {
        resetSearch: function () {
            this.$store.commit('MULT_SET_CURRENT_INDUSTRY', null);
            this.$store.commit('MULT_SET_CURRENT_SALES_CLASS', null);
            this.$store.commit('MULT_SET_COUNT', null);
        },
        closeArea: function () {
            let all_el = document.querySelectorAll('.filter_list li');
            all_el.forEach(function (x) {
                x.classList.remove('show');
            })
        },
        showExtendArea: function (e) {
            e.stopPropagation();
            let el = e.currentTarget;
            let pos = el.offsetTop;
            let all_el = document.querySelectorAll('.filter_list li');
            let dropDown = document.querySelectorAll('.dropdown_area');
            let scrl = document.querySelector('.search_panel').scrollTop;
            let elem = el.querySelector('.dropdown_area');
            let screen = window.innerHeight - 75;
            elem.style.top = 'auto';
            if (el.classList.contains('show')) {
                el.classList.remove('show');
            } else {
                all_el.forEach(function (x) {
                    x.classList.remove('show');
                })
                el.classList.add('show');
            }
            dropDown.forEach(function (x) {
                x.addEventListener('click', function (e) {
                    e.stopPropagation();
                });
            })
            if (screen < (elem.offsetHeight + pos)) {
                elem.style.bottom = 10 + 'px';
                elem.style.top = 'auto';
            }
            else {
                elem.style.top = (pos + 75) - scrl + 'px';
                elem.style.bottom = 'auto';
            }

            var favSelects = document.querySelectorAll('.favourite_list');
            [].forEach.call(favSelects, function (el) {
                el.classList.remove('open');
            });
        },
        selectArea: function (e) {
            let parentDiv = document.querySelectorAll('.custom-step-pro');
            let deactiveClass = document.querySelectorAll('.step-progress__step');
            let favoriteDropdown = document.querySelectorAll('.favourite_list');
            deactiveClass.forEach(function (el) {
                el.classList.remove('open');
            });
            favoriteDropdown.forEach(function (el) {
                el.classList.remove('open');
            });
            parentDiv.forEach(function (el) {
                el.addEventListener('click', function (e) {
                    e.stopPropagation();
                });
            });
        },
        getData: async function () {
            let currentSession = localStorage.getItem(
                'vue-authenticate.vueauth_access_token'
            );
            await axios
                .post(
                    process.env.VUE_APP_API_BASE_URL + '/user/search/multiples',
                    {},
                    {
                        params: {
                            /**
                             * Required parameters:
                             */
                            session_id: currentSession,
                        },
                    }
                )
                .then((res) => {
                    this.dataAccess = res.data;

                    this.$store.commit('MULT_SET_ALLOWED_SALES_CLASS', this.dataAccess.allowedSalesClasses);
                    this.$store.commit('MULT_SET_INDUSTRIES', this.dataAccess.industries);
                    this.$store.commit('MULT_SET_NAICS3LIST', this.dataAccess.naics3list);
                    this.$store.commit('MULT_SET_NAME_LIST', this.dataAccess.nameList);
                    this.$store.commit('MULT_SET_REMOVED_SALES_CLASS', this.dataAccess.removedSalesClasses);
                    this.$store.commit('MULT_SET_SEARCH', this.dataAccess.search);
                    this.$store.commit('MULT_SET_SEARCHES_ALLOWED', this.dataAccess.searchesAllowed);
                    this.$store.commit('MULT_SET_SEARCHES_USED', this.dataAccess.searchesUsed);
                    this.$store.commit('MULT_SET_SECTORS', this.dataAccess.sectors);
                });
        },
    },
    watch: {
        multCount(newValue, oldValue) {
            if (newValue > 2)
                this.isHiddenSalesSelect = false
            else
                this.isHiddenSalesSelect = true
        }
    }
}
</script>
<style>
.div-table {
    padding-left: 30rem;
    padding-right: 30rem;
    text-align-last: center;
}
.table-header {
    background-color: #133a64 !important;
    color: white !important;
    font-weight: 500 !important;
}
.table-title {
    text-align-last: start !important;
    font-weight: 500 !important;
}
.table-content {
    color: #3b7ef1 !important;
    font-weight: 500 !important;
}
.reset-button {
    border-radius: 55px !important;
}
.div-button {
    padding-left: 15rem;
    padding-right: 25rem;
}
</style>